import React from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";

export const GLOBALS={
  activeAffiliation:"VIGEN",
  footerImage: "https://www.cibercolegios.com/img/logo_ciber2.png",
  defaultColor: "#f8d720",
  defaultEmail: "soporte@cibercolegios.com"
}

export const MESSAGES = {
  "OLVIDO_CONTRASENIA": "Si ha olvidado alguno de sus datos de acceso por favor ingrese a continuación la dirección de correo electrónico registrada en el sistema, para enviarle via correo electrónico su acceso.",
  "CIB-GEN-0017": "Apreciado usuario, este portal es exclusivo para servicios de educación. Actualmente no se encuentra registrado en ninguna de nuestras instituciones educativas.",
  "CIB-GEN-0022": "Su sesión ha expirado",
  "CIB-GEN-0002": "Los datos ingresados o contraseña son incorrectos: En caso de haberlos olvidado, comuníquese con el administrador del sistema de su institución",
  "CIB-GEN-0023": "Su afiliación no está vigente",
  "CIB-GEN-0024": "No tiene beneficiarios disponibles",
  "CIB-GEN-0026": "El tiempo del proceso de inscripción en el colegio seleccionado ha finalizado, por favor seleccione otra institución",
  "CIB-GEN-0027": "Ha ocurrido un error inesperado por favor comuníquese con el administrador del sistema",
  "CIB-GEN-0028": "Estimado Padre de Familia, le informamos que en este momento no se encuentra habilitado ningún proceso de inscripción, si usted presenta alguna inquietud le agradecemos comunicarse a la línea 7457900 en Bogotá o línea Nacional 018000 94 7900 de Lunes a Sábado de 07:00 a.m. a 07:00 p.m., en donde le podrán ayudar al respecto.",
  "ANY": "Error Desconocido Por favor consulte al administrador para tener más contexto del error",
  "SUCCESS": "Hemos enviado la información a la institución para que se pueda verificar el caso",
  "CIB-GEN-6665": "Problema recuperando su password, contáctese con el administrador",
  "CIB-GEN-0030":"El aspirante no puede ser inscrito, ya que se encuentra registrado como aspirante o estudiante en otra institución",
  "CIB-GEN-0031":"El tiempo del proceso de inscripción en el colegio seleccionado ha finalizado",
  "VIGEN": "(Afiliación Vigente)",
  "RETIR": "(Afiliación Retirado)",
  "WELCOME_MESSAGE": "Al proceso de inscripción del colegio, tenga presente que la información registrada le permite inscribir a su hijo como aspirante dentro del proceso de admisión, si tiene alguna inquietud comuniquese con el colegio al correo:",
  "NOTE": "NOTA IMPORTANTE: El proceso de matrícula se realiza únicamente en el colegio y grado que usted seleccione, no es posible realizar cambios durante el proceso de matrícula ni una vez finalizado el proceso."
};



  class CiberAlerts extends React.Component {

  render() {
    let code = '';
    let message = '';
    if (this.props.code) {
      code = this.props.code
      message = MESSAGES[code]
    } else {
      try {
        code = this.props.error.graphQLErrors[0].extensions.code;
        message = MESSAGES[code];
      } catch (e) {
        try {
          code = this.props.error.networkError.result.message;
          message = MESSAGES[code];
        } catch (e) {
          code = "ANY";
          message = MESSAGES["ANY"]
        }
      }
    }

    if (code === "CIB-GEN-0025") {
      let grade =  this.props.error.graphQLErrors[0].extensions.message;
      if (grade === "Level not corresponding for age") {
        grade = null;
      }
        return (
          <Alert variant="secondary">
            <Alert.Heading>¡La solicitud no ha podido procesarse!</Alert.Heading>
            <h5>
              El aspirante no puede ser inscrito en el grado seleccionado, por alguna de las siguientes razones:
            </h5>
            <ul>
              <li>1. No cumple con la edad requerida para el ciclo seleccionado, en este caso dar clic en el botón reportar para enviar la información al Colegio y que sea estudiado el caso.
              </li>
              <li>2. Seleccionó un grado incorrecto, por favor realice el cambio e intente nuevamente con el botón Diligenciar inscripción.
              </li>
              <li>
                3. No existen cupos disponibles para el grado seleccionado, en este caso dar clic en el botón reportar para enviar la solicitud al colegio y que sea estudiado el caso.
              </li>
            </ul>
            <hr/>
            <Button className="btn btn-info" onClick={() => this.props.callBack()}>Reportar</Button>
          </Alert>
        );
    }
    else {

      return (
        <Alert variant="warning">
          <Alert.Heading>¡La solicitud no ha podido procesarse!</Alert.Heading>
          <h5>{message}
          </h5>
        </Alert>
      )
    }
  }
}

export default CiberAlerts;

